import React, { FC } from 'react';
import { SaveYourProjectAndContinueProps } from '.';
import { SaveToYourProject } from '@components/SaveToCTA/SaveToYourProject';
import { Pages } from 'src/types/pages';
import { ContinueCTAButton } from '@components/ContinueCTAButton';
const SaveYourProjectAndContinueTemplate: FC<SaveYourProjectAndContinueProps> = ({
    className,
    page,
    isCtaDisabled = false,
}) => {
    const translationKey: { [key: string]: string } = {
        [Pages.summary]: 'cta.continueOnlineBtn',
    };

    return (
        <div className={className}>
            <SaveToYourProject page={page} additionalClassName="button" />
            <ContinueCTAButton
                disabled={isCtaDisabled}
                page={page}
                translationKey={translationKey[page]}
                fullWidth
                htmlId="TESTING_TO_BASKET_BOX_INTERESTEDBOX"
                className="button"
                position="summary-page"
            />
        </div>
    );
};
export default SaveYourProjectAndContinueTemplate;
